import * as types from './types'

const initialState = {
  pagedLayouts: null,
  pendingLayouts: false,
  layoutOptions: null,
  pendingLayoutOptions: false,
  pagedSectors: null,
  pendingSectors: false,
  sectors: null,
  seats: null,
  pendingSeats: false,
  seatsInfo: null,
  pendingSeatsInfo: false,
  layout: null,
  pendingLayout: false,
  pendingCrateLayout: false,
  pendingUpdateLayout: false,
  sector: null,
  pendingSector: false,
  pendingCreateSector: false,
  pendingUpdateSector: false,
  pendingCreateSeats: false,
  pendingUpdateSeats: false,
  pendingDeleteLayout: false,
  layoutDeleted: null,
  pendingDeleteSector: false,
  sectorDeleted: null,
  pendingAssign: false,
  tickets: null,
  pendingTicket: false,
  assignedTicket: null,
  pendingAssignTicket: false,
  error: null,
  reqParams: null
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case types.PAGED_LAYOUTS_ATTEMPT:
      return {
        ...state,
        pendingLayouts: true,
        error: null,
        pagedLayouts: null,
        reqParams: action.reqParams
      }
    case types.PAGED_LAYOUTS_SUCCESS:
      return {
        ...state,
        pendingLayouts: false,
        error: null,
        pagedLayouts: action.pagedLayouts
      }
    case types.PAGED_LAYOUTS_FAILURE:
      return {
        ...state,
        pendingLayouts: false,
        error: action.error,
        pagedLayouts: null
      }
    case types.LOAD_LAYOUT_OPTIONS_ATTEMPT:
      return {
        ...state,
        pendingLayoutOptions: true,
        error: null,
        layoutOptions: null,
        reqParams: action.reqParams
      }
    case types.LOAD_LAYOUT_OPTIONS_SUCCESS:
      return {
        ...state,
        pendingLayoutOptions: false,
        error: null,
        layoutOptions: action.layoutOptions
      }
    case types.LOAD_LAYOUT_OPTIONS_FAILURE:
      return {
        ...state,
        pendingLayoutOptions: false,
        error: action.error,
        layoutOptions: null
      }
    case types.PAGED_SECTORS_ATTEMPT:
      return {
        ...state,
        pendingSectors: true,
        error: null,
        pagedSectors: null,
        reqParams: action.reqParams
      }
    case types.PAGED_SECTORS_SUCCESS:
      return {
        ...state,
        pendingSectors: false,
        error: null,
        pagedSectors: action.pagedSectors
      }
    case types.PAGED_SECTORS_FAILURE:
      return {
        ...state,
        pendingSectors: false,
        error: action.error,
        pagedSectors: null
      }
    case types.LOAD_SECTORS_ATTEMPT:
      return {
        ...state,
        pendingSectors: true,
        error: null,
        sectors: null,
        reqParams: action.reqParams
      }
    case types.LOAD_SECTORS_SUCCESS:
      return {
        ...state,
        pendingSectors: false,
        error: null,
        sectors: action.sectors
      }
    case types.LOAD_SECTORS_FAILURE:
      return {
        ...state,
        pendingSectors: false,
        error: action.error,
        sectors: null
      }
    case types.LOAD_SEATS_ATTEMPT:
      return {
        ...state,
        pendingSeats: true,
        seats: null,
        error: null
      }
    case types.LOAD_SEATS_SUCCESS:
      return {
        ...state,
        pendingSeats: false,
        seats: action.seats,
        error: null
      }
    case types.LOAD_SEATS_FAILURE:
      return {
        ...state,
        pendingSeats: false,
        seats: null,
        error: action.error
      }
    case types.LOAD_SEATS_INFO_SELL_ATTEMPT:
      return {
        ...state,
        pendingSeatsInfo: true,
        seatsInfo: null,
        error: null
      }
    case types.LOAD_SEATS_INFO_SELL_SUCCESS:
      return {
        ...state,
        pendingSeatsInfo: false,
        seatsInfo: action.seatsInfo,
        error: null
      }
    case types.LOAD_SEATS_INFO_SELL_FAILURE:
      return {
        ...state,
        pendingSeatsInfo: false,
        seatsInfo: null,
        error: action.error
      }
    case types.LOAD_LAYOUT_ATTEMPT:
      return {
        ...state,
        pendingLayout: true,
        layout: null,
        error: null
      }
    case types.LOAD_LAYOUT_SUCCESS:
      return {
        ...state,
        pendingLayout: false,
        layout: action.layout,
        error: null
      }
    case types.LOAD_LAYOUT_FAILURE:
      return {
        ...state,
        pendingLayout: false,
        layout: null,
        error: action.error
      }
    case types.LOAD_SECTOR_ATTEMPT:
      return {
        ...state,
        pendingSector: true,
        sector: null,
        error: null
      }
    case types.LOAD_SECTOR_SUCCESS:
      return {
        ...state,
        pendingSector: false,
        sector: action.sector,
        error: null
      }
    case types.LOAD_SECTOR_FAILURE:
      return {
        ...state,
        pendingSector: false,
        sector: null,
        error: action.error
      }
    case types.CREATE_LAYOUT_ATTEMPT:
      return {
        ...state,
        layout: null,
        pendingCreateLayout: true,
        error: null
      }
    case types.CREATE_LAYOUT_SUCCESS:
      return {
        ...state,
        layout: action.layout,
        pendingCreateLayout: false,
        error: null
      }
    case types.CREATE_LAYOUT_FAILURE:
      return {
        ...state,
        layout: null,
        pendingCreateLayout: false,
        error: action.error
      }
    case types.UPDATE_LAYOUT_ATTEMPT:
      return {
        ...state,
        layout: null,
        pendingUpdateLayout: true,
        error: null
      }
    case types.UPDATE_LAYOUT_SUCCESS:
      return {
        ...state,
        layout: action.layout,
        pendingUpdateLayout: false,
        error: null
      }
    case types.UPDATE_LAYOUT_FAILURE:
      return {
        ...state,
        layout: null,
        pendingUpdateLayout: false,
        error: action.error
      }
    case types.CREATE_SECTOR_ATTEMPT:
      return {
        ...state,
        sector: null,
        pendingCreateSector: true,
        error: null
      }
    case types.CREATE_SECTOR_SUCCESS:
      return {
        ...state,
        sector: action.sector,
        pendingCreateSector: false,
        error: null
      }
    case types.CREATE_SECTOR_FAILURE:
      return {
        ...state,
        sector: null,
        pendingCreateSector: false,
        error: action.error
      }
    case types.UPDATE_SECTOR_ATTEMPT:
      return {
        ...state,
        sector: null,
        pendingUpdateSector: true,
        error: null
      }
    case types.UPDATE_SECTOR_SUCCESS:
      return {
        ...state,
        sector: action.sector,
        pendingUpdateSector: false,
        error: null
      }
    case types.UPDATE_SECTOR_FAILURE:
      return {
        ...state,
        sector: null,
        pendingUpdateSector: false,
        error: action.error
      }
    case types.CREATE_SEATS_ATTEMPT:
      return {
        ...state,
        seats: null,
        pendingCreateSeats: true,
        error: null
      }
    case types.CREATE_SEATS_SUCCESS:
      return {
        ...state,
        seats: action.seats,
        pendingCreateSeats: false,
        error: null
      }
    case types.CREATE_SEATS_FAILURE:
      return {
        ...state,
        seats: null,
        pendingCreateSeats: false,
        error: action.error
      }
    case types.UPDATE_SEATS_ATTEMPT:
      return {
        ...state,
        pendingUpdateSeats: true,
        error: null
      }
    case types.UPDATE_SEATS_SUCCESS:
      return {
        ...state,
        seats: action.seats,
        pendingUpdateSeats: false,
        error: null
      }
    case types.UPDATE_SEATS_FAILURE:
      return {
        ...state,
        pendingUpdateSeats: false,
        error: action.error
      }
    case types.DELETE_SECTOR_ATTEMPT:
      return {
        ...state,
        pendingDeleteSector: true,
        sectorDeleted: null,
        error: null
      }
    case types.DELETE_SECTOR_SUCCESS:
      return {
        ...state,
        pendingDeleteSector: false,
        sectorDeleted: action.sectorDeleted,
        error: null
      }
    case types.DELETE_SECTOR_FAILURE:
      return {
        ...state,
        pendingDeleteSector: false,
        sectorDeleted: null,
        error: action.error
      }
    case types.DELETE_LAYOUT_ATTEMPT:
      return {
        ...state,
        pendingDeleteLayout: true,
        layoutDeleted: null,
        error: null
      }
    case types.DELETE_LAYOUT_SUCCESS:
      return {
        ...state,
        pendingDeleteLayout: false,
        layoutDeleted: action.layoutDeleted,
        error: null
      }
    case types.DELETE_LAYOUT_FAILURE:
      return {
        ...state,
        pendingDeleteLayout: false,
        layoutDeleted: null,
        error: action.error
      }
    case types.ASSIGN_LAYOUT_ATTEMPT:
      return {
        ...state,
        layout: null,
        pendingAssign: true,
        error: null
      }
    case types.ASSIGN_LAYOUT_SUCCESS:
      return {
        ...state,
        layout: action.layout,
        pendingAssign: false,
        error: null
      }
    case types.ASSIGN_LAYOUT_FAILURE:
      return {
        ...state,
        layout: null,
        pendingAssign: false,
        error: action.error
      }
    case types.LOAD_ASSIGNABLE_TICKETS_ATTEMPT:
      return {
        ...state,
        pendingTickets: true,
        tickets: null,
        error: null
      }
    case types.LOAD_ASSIGNABLE_TICKETS_SUCCESS:
      return {
        ...state,
        pendingTickets: false,
        tickets: action.tickets,
        error: null
      }
    case types.LOAD_ASSIGNABLE_TICKETS_FAILURE:
      return {
        ...state,
        pendingTickets: false,
        tickets: null,
        error: action.error
      }
    case types.ASSIGN_TICKET_TO_SECTOR_ATTEMPT:
      return {
        ...state,
        assignedTicket: null,
        pendingAssignTicket: true,
        error: null
      }
    case types.ASSIGN_TICKET_TO_SECTOR_SUCCESS:
      return {
        ...state,
        assignedTicket: action.assignedTicket,
        pendingAssignTicket: false,
        error: null
      }
    case types.ASSIGN_TICKET_TO_SECTOR_FAILURE:
      return {
        ...state,
        assignedTicket: null,
        pendingAssignTicket: false,
        error: action.error
      }
    case types.RESET:
      return {
        ...state,
        ...initialState
      }
    case types.RESET_ACTIONS:
      return {
        ...state,
        pending: false,
        actionPending: false,
        actionSuccess: false
      }
    case types.RESET_PARAMS:
      return {
        ...state,
        reqParams: null
      }
    default:
      return state
  }
}
